import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export const ForgetPage = ({ forgotPassword, isSent, isLoading }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();

  const onSubmit = (data) => {
    forgotPassword(data);
  };

  return (
    <>
      <div className="full-row bg-light overlay-dark py-5"
        style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <h3 className="mb-2 text-white font-weight-bold">Forget Password Page</h3>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center bg-transparent">
                  <li className="breadcrumb-item">
                    <a href="#" className="text-white">Home</a>
                  </li>
                  <li className="breadcrumb-item active text-white" aria-current="page">Forget Passowrd</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div className="container d-flex justify-content-center align-items-center py-5">
        <div className="card p-4" style={{width: "100%", maxWidth: "600px"}}>
          <h4 className="mb-4" style={{fontWeight: 700, fontSize: "30px"}}>Forget password</h4>
          <form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label for="email" className="form-label text-secondary">Email address<span className="text-danger">*</span></label>
              <input type="text" name="email" {...register('email', { required: 'Email address is required' })} className="form-control" id="email" placeholder="Type Email Address"/>
              {errors.email && <p className="text-danger px-2">{errors.email.message}</p>}
            </div>
            <div className="d-flex justify-content-between mb-3">
              <Link to="/login" className="text-decoration-none text-dark">Remember password?</Link>
            </div>

            <button type="submit" className="btn w-100"
              style={{backgroundColor: "#424A4D", borderRadius: 0, color: "white", height: "40px"}}>Send Link</button>
          </form>
        </div>
      </div>
    </>
  );
};
